import pick from 'lodash.pick';
import { persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

type State = {
  isShowingHidden: boolean;
  toggleShowHidden: () => void;
};

const useStore = createWithEqualityFn<State>()(
  persist(
    (set, get) => ({
      isShowingHidden: false,
      toggleShowHidden: () => set({ isShowingHidden: !get().isShowingHidden }),
    }),
    {
      name: '_ah_show_hidden_source_events',
      partialize: (state) => pick(state, 'isShowingHidden'),
    }
  ),
  shallow
);

export const useShowHiddenSourceEvents = () => useStore();
